export class CountryDetailsDataResponse {
    constructor(
        public CountryDetails: CountryDetails[]
    ) { }
}
export class CountryDetails{
    id:string;
    value:string;
}    

export class CountryDetailsRow {
  CountryName: string;
  CountryCode: string;
  TravelOnly: boolean;
  ExPats: boolean;
  NumberExPats: string;
  LocalNats: boolean;
  NumberLocalNats: string
    constructor() {}
  }
  
export class CountryDetailsList {
  countryDetailsData: CountryDetailsRow[];
} 

  